import { Flex } from 'antd'
import Icon, { IconName } from '@/components/icon'
import Styles from './style.module.scss'

interface DataItemProps {
  icon: IconName
  title: string
  description: string
}

const TITLE = 'Fleet & Charging Needs'
const DESCRIPTION = 'Key Insight: PV + ESS ensures stable, low-cost charging without overloading the grid'
const data: DataItemProps[] = [
  {
    icon: 'grayBattery',
    title: 'Battery Capacity',
    description: 'Each bus has a battery capacity of 150-300kWh',
  },
  {
    icon: 'bus',
    title: 'Fleet Demand',
    description: 'A fleet of 10 buses requires approximately 600 kWh per day',
  },
  {
    icon: 'time',
    title: 'Charging Time',
    description: 'Buses are charged overnight, from 7 p.m.to early morning',
  },
]

export default function Need() {
  return (
    <div className={Styles.need}>
      <h2>{TITLE}</h2>
      <div className={Styles.description}>{DESCRIPTION}</div>
      <Flex align='center' className={Styles.content}>
        {data.map(item => (
          <Flex align='flex-start' key={item.title} className={Styles.item}>
            <Icon name={item.icon} className={Styles.icon} />
            <Flex vertical className={Styles.textWrapper}>
              <div className={Styles.title}>{item.title}</div>
              <div className={Styles.textDescription}>{item.description}</div>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
